import React from "react";
import { Step } from "semantic-ui-react";

const ForgotPasswordSteps = props => (
  <Step.Group ordered>
    <Step active={props.steps[0] === 1} completed={props.steps[0] === 2}>
      <Step.Content>
        <Step.Title>Account Info</Step.Title>
      </Step.Content>
    </Step>

    <Step active={props.steps[1] === 1} completed={props.steps[1] === 2}>
      <Step.Content>
        <Step.Title>Email Confirmation</Step.Title>
      </Step.Content>
    </Step>

    <Step active={props.steps[2] === 1} completed={props.steps[2] === 2}>
      <Step.Content>
        <Step.Title>Choose Password</Step.Title>
      </Step.Content>
    </Step>
  </Step.Group>
);

export default ForgotPasswordSteps;



// WEBPACK FOOTER //
// ./src/components/pages/ForgotPasswordSteps.js